module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/wbs-allocation-methods/wbs-allocation-methods.component.css
// module id = ./src/app/wbs-allocation-methods/wbs-allocation-methods.component.css
// module chunks = main